import styled from "styled-components";
import Text from "antd/es/typography/Text";

export const TextCustom = styled(Text)`
  padding: 5px 0px;
  margin-left: 5px;
`;
